import { GetServerSideProps, NextPage } from 'next';
import React from 'react';

import { pagesConfigStore } from '~/atomic/atom/links/pagesConfigStore';
import { LayoutType } from '~/atomic/layout/DefaultLayout';
import { PageTemplate } from '~/atomic/organism/PageTemplate/PageTemplate';
import { AntiPirateLandingPage } from '~/atomic/page/anti-pirate/AntiPirateLandingPage';
import { checkAuthToken } from '~/feature/authorization/checkAuthToken';
import { SiteTemplate } from '~/feature/template/SiteTemplate';
import { createStore, RootState } from '~/store';

const AntiPiratePage: NextPage & LayoutType = () => {
  const title = 'Защита произведений авторов от книжных пиратов';
  const description = 'Для защиты книги автор особенным образом маркирует текст глав. '
    + 'Благодаря маркировке, может найти нарушителя и заблокировать доступ к новым главам.';

  return (
    <PageTemplate
      isPublic={pagesConfigStore.antiPirate.isPublic}
      seo={{
        title,
        description,
        canonical: pagesConfigStore.antiPirate.url,
      }}
      content={(<AntiPirateLandingPage />)}
    />
  );
};

AntiPiratePage.getLayout = (page) => (
  <SiteTemplate>
    { page }
  </SiteTemplate>
);

export const getServerSideProps: GetServerSideProps<
{ state: RootState; },
{ genres: string[]; }
> = async (context) => {
  const { dispatch, store } = await createStore();
  const isLoggedIn = await checkAuthToken(context, dispatch);

  const state = store.getState();
  return { props: { state } };
};

export default AntiPiratePage;
